import { render } from "./PhoneticInputs.vue?vue&type=template&id=4b0dece6&scoped=true"
import script from "./PhoneticInputs.vue?vue&type=script&lang=js"
export * from "./PhoneticInputs.vue?vue&type=script&lang=js"

import "@/css/components/phonetic-inputs.css?vue&type=style&index=0&id=4b0dece6&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0dece6"]])

export default __exports__